import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-pizza',
  templateUrl: './create-pizza.component.html',
  styleUrls: ['./create-pizza.component.css']
})
export class CreatePizzaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
